// Language translations
export const translations = {
  en: {
    // App title and basic labels
    appName: 'ListWiz',
    appDescription: 'Create, share, and manage your lists with ease',
    
    // Common actions
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    update: 'Update',
    share: 'Share',
    close: 'Close',
    confirm: 'Confirm',
    alert: 'Alert',
    loading: 'Loading...',
    back: 'Back',
    quickAdd: 'Quick Add',
    customize: 'Customize',
    quickAddSettings: 'Quick Add Settings',
    maxItems: 'Number of items',
    disabled: 'Disabled',
    autoGenerate: 'Auto-generate from your shopping history',
    quickAddInfo: 'Quick add items are based on what you commonly add to this specific list.',
    manageItems: 'Manually Manage Items',
    manageQuickAdd: 'Manage Quick Add Items',
    addQuickItem: 'Type item name, category...',
    addNewQuickItem: 'Add New Quick Item',
    itemName: 'Item name',
    currentQuickItems: 'Current Quick Items',
    noQuickItems: 'No quick add items configured.',
    quickItemsHelp: 'Add items above to create your custom quick add list.',
    quickAddManagerInfo: 'These items will appear as quick-add buttons for this specific list. You can drag to reorder them.',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    errorSaving: 'Error saving changes. Please try again.',
    
    // Manage suggestions
    manageSuggestions: 'Manage Suggestions',
    manageSuggestionsDesc: 'Review and delete unwanted suggestions from your shopping history',
    searchSuggestions: 'Search suggestions...',
    show: 'Show',
    allItems: 'All items',
    unused: 'Unused (30+ days)',
    recent: 'Recent (7 days)',
    sortBy: 'Sort by',
    frequency: 'Frequency',
    lastUsed: 'Last used',
    name: 'Name',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    deleteSelected: 'Delete selected',
    noSuggestions: 'No suggestions found',
    noSuggestionsDesc: 'Try adjusting your search or filters.',
    deleteItem: 'Delete this suggestion',
    totalSuggestions: 'Total suggestions',
    showing: 'Showing',
    
    // Basic terms  
    lists: 'Lists',
    days: 'Days',
    items: 'Items',
    administrator: 'Administrator',
    member: 'Member',
    joined: 'Joined',
    notAvailable: 'N/A',
    
    // Error messages
    networkErrorBackendNotRunning: 'Network error - backend might not be running',
    
    // Time formatting
    oneDay: '1 day',
    daysCount: '{0} days',
    monthsCount: '{0} months',
    yearsCount: '{0} years',
    
    // Shopping list terms
    items: 'items',
    checked: 'checked',
    complete: 'Complete',
    active: 'Active',
    empty: 'Empty',
    
    // Categories
    categories: {
      'General': 'General',
      'Groceries': 'Groceries',
      'Household': 'Household',
      'Personal Care': 'Personal Care',
      'Health & Beauty': 'Health & Beauty',
      'Electronics': 'Electronics',
      'Clothing': 'Clothing',
      'Books': 'Books',
      'Health': 'Health',
      'Pharmacy': 'Pharmacy',
      'Hardware': 'Hardware'
    },
    
    // Form labels
    welcomeBack: 'Welcome back',
    appSlogan: 'Smart Lists Made Simple',
    createFirstList: 'Start by creating your first list. Organize, share, and never forget an item again!',
    listName: 'List Name',
    description: 'Description',
    itemName: 'Item Name',
    quantity: 'Quantity',
    category: 'Category',
    notes: 'Notes',
    optional: 'Optional',
    done: 'Done',
    adding: 'Adding...',
    quickAdd: 'Quick Add',
    
    // Authentication
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    confirmPassword: 'Confirm Password',
    loginFailed: 'Login failed. Please check your credentials.',
    registrationFailed: 'Registration failed. Please try again.',
    registrationSuccess: 'Account created successfully! Please login.',
    emailExists: 'An account with this email already exists.',
    
    // Settings and Profile
    welcomeBack: 'Welcome back',
    createFirstList: 'Start by creating your first list. Organize, share, and never forget an item again!',
    settings: 'Settings',
    settingsDescription: 'Customize your ListWiz experience',
        profileItems: 'Elementer',
    
    // Account Settings section
    accountSettings: 'Kontoinnstillinger',
    managePersonalInfo: 'Administrer din personlige informasjon',
    displayName: 'Visningsnavn',
    emailAddress: 'E-postadresse',
    accountStatus: 'Kontostatus',
    statusActive: 'Aktiv',
    editProfile: 'Rediger profil',
    changePassword: 'Endre passord',
    currentPassword: 'Nåværende passord',
    newPassword: 'Nytt passord',
    confirmPassword: 'Bekreft passord',
    saveChanges: 'Lagre endringer',
    saving: 'Lagrer...',
    cancel: 'Avbryt',
    
    // Activity section
    yourActivity: 'Din aktivitet',
    shoppingInsights: 'Handlingsinnsikt og fremgang',
    startShoppingJourney: 'Start din handlereise!',
    // Account Settings section
    accountSettings: 'Account Settings',
    managePersonalInfo: 'Manage your personal information',
    displayName: 'Display Name',
    emailAddress: 'Email Address',
    accountStatus: 'Account Status',
    statusActive: 'Active',
    editProfile: 'Edit Profile',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    cancel: 'Cancel',
    
    // App Settings section
    appSettings: 'App Settings',
    fontSize: 'Font Size',
    current: 'Current',
    fontSizeDescription: 'Adjust text size for better readability on your device',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    xlarge: 'X-Large',
    huge: 'Huge',
    
    // Display Settings
    displaySettings: 'Display Settings',
    showCategories: 'Show Categories',
    showCategoriesDescription: 'Show category headers in your shopping lists by default',
    showQuickAddButtons: 'Show Quick Add Buttons',
    showQuickAddButtonsDescription: 'Show category buttons under the quick add text input',
    quickAddButtons: 'Quick Add Buttons',
    categoriesDisplay: 'Categories',
    useGlobalSetting: 'Use Global Setting',
    alwaysShow: 'Always Show',
    alwaysHide: 'Always Hide',
    
    // Activity section
    yourActivity: 'Your Activity',
    shoppingInsights: 'Activity insights & progress',
    startShoppingJourney: 'Start Your List Journey!',
    createFirstListMessage: 'Create your first list to see your activity stats here.',
    createFirstList: 'Create Your First List',
    shoppingLists: 'Lists',
    totalItems: 'Total Items',
    avgProgress: 'Avg. Progress',
    efficiencyScore: 'efficiency score',
    shared: 'shared',
    completed: 'completed',
    
    // Data Retention section
    dataRetentionPolicies: 'Data Retention Policies',
    monitorDataCleanup: 'Monitor and manage automatic data cleanup to maintain system performance. This feature helps keep your data organized by removing old, unused shopping lists and items based on configurable retention periods.',
    itemsEligibleForCleanup: 'Items eligible for cleanup',
    maximumDataAge: 'Maximum data age',
    runDataCleanup: 'Run Data Cleanup',
    runningCleanup: 'Running Cleanup...',
    lastCleanupResults: 'Last Cleanup Results',
    itemsCleaned: 'Items cleaned:',
    listsCleaned: 'Lists cleaned:',
    loadingDataRetention: 'Loading data retention information...',
    manageDataRetention: 'Manage Data Retention',
    hideDataRetention: 'Hide Data Retention',
    dataCleanupInfo: 'Click the button below to manually run data cleanup. This will remove inactive users based on their personal retention preference (1 year, 2 years, or indefinite). When a user is deleted, all their lists and data are also removed.',
    dataCleanupWarning: '⚠️ This action permanently deletes inactive users and all their data.',
    confirmDataRetentionCleanup: 'Are you sure you want to run data retention cleanup?\n\nThis will permanently delete:\n• Users who haven\'t logged in within their chosen retention period\n• All lists and data belonging to those inactive users\n• Orphaned lists (lists without owners)\n\nActive users and their lists are never deleted, regardless of list age. Admin users are never deleted. This action cannot be undone.',
    profileDescription: 'Manage your account information and preferences.',
    statistics: 'Statistics',
    statisticsDescription: 'Your shopping activity and achievements.',
    languages: 'Languages',
    languageDescription: 'Set your interface and content language preferences.',
    notifications: 'Notifications',
    dataAndPrivacy: 'Data & Privacy',
    administration: 'Administration',
    personalInformation: 'Personal Information',
    personalInformationDescription: 'Update your name and password.',
    editProfile: 'Edit Profile',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    changePassword: 'Change Password',
    changePasswordDescription: 'Toggle to change your password',
    currentPassword: 'Current Password',
    enterCurrentPassword: 'Enter your current password',
    newPassword: 'New Password',
    enterName: 'Enter your name',
    enterNewPassword: 'Enter new password',
    confirmNewPassword: 'Confirm new password',
    nameRequired: 'Name is required.',
    oldPasswordRequired: 'Current password is required to change password.',
    newPasswordRequired: 'New password is required.',
    passwordTooShort: 'New password must be at least 6 characters long.',
    passwordsDoNotMatch: 'New passwords do not match.',
    profileUpdated: 'Profile updated successfully.',
    profileUpdateFailed: 'Failed to update profile. Please try again.',
    memberSince: 'Member since',
    administrator: 'Administrator',
    unknown: 'Unknown',
    success: 'Success',
    error: 'Error',
    info: 'Info',
    
    // Category management - missing keys
    categoryAlreadyExists: 'The category "{0}" already exists.',
    duplicateCategory: 'Duplicate Category',
    confirmDelete: 'Confirm Delete',
    standardCategory: 'Standard',
    customCategory: 'Custom',
    yourCategories: 'Your Categories',
    categoryNamePlaceholder: 'Enter category name...',
    noCategories: 'No Categories Yet',
    emptyCategoriesHint: 'Start by creating your first category above. Categories help you organize your list items efficiently.',
    createCategoryHint: 'Create custom categories for your lists',
    noCategoryFallback: 'No Category',
    
    // Admin management - missing keys
    loadingAdminData: 'Loading admin data...',
    user: 'User',
    joined: 'Joined',
    actions: 'Actions',
    owned: 'owned',
    shared: 'shared',
    confirmDeleteUser: 'Are you sure you want to delete user "{0}" ({1})? This will also delete all their lists and data.',
    confirmToggleAdmin: 'Are you sure you want to {0} "{1}"?',
    confirmToggleBlocked: 'Are you sure you want to {0} "{1}"?',
    updateUserRole: 'Update User Role',
    updateUserStatus: 'Update User Status',
    userNotFound: 'User not found. The user list has been refreshed.',
    failedToLoadAdminData: 'Failed to load admin data. Please try again.',
    
    // Admin User Management
    totalUsers: 'Total Users',
    administrators: 'Administrators',
    blockedUsers: 'Blocked Users',
    users: 'Users',
    searchUsers: 'Search users...',
    allUsers: 'All Users',
    activeUsers: 'Active',
    showingUsers: 'Showing {0}-{1} of {2} users',
    previous: 'Previous',
    next: 'Next',
    show: 'Show',
    
    // Admin System Stats
    totalLists: 'Total Lists',
    totalItems: 'Total Items',
    completionRate: 'Completion Rate',
    withLists: 'with lists',
    avgPerUser: 'avg per user',
    completed: 'completed',
    systemAverage: 'System average',
    systemHealth: 'System Health',
    uptime: 'Uptime',
    memory: 'Memory',
    
    // Admin List Management
    searchLists: 'Search lists...',
    total: 'Total',
    shared: 'Shared',
    by: 'by',
    items: 'items',
    private: 'Private',
    viewListDetails: 'View List Details',
    editList: 'Edit List',
    unblockList: 'Unblock List',
    blockList: 'Block List',
    transferOwnership: 'Transfer Ownership',
    deleteList: 'Delete List',
    showingLists: 'Showing {0}-{1} of {2} lists',
    // View List Modal
    loadingListDetails: 'Loading list details...',
    overview: 'Overview',
    owner: 'Owner',
    created: 'Created',
    totalItems: 'Total Items',
    completed: 'Completed',
    shared: 'Shared',
    users: 'users',
    progress: 'Progress',
    items: 'Items',
    viewOnly: 'View Only',
    collaborative: 'Collaborative',
    sharedList: 'Shared list',
    defaultList: 'Default list',
    collaborativeList: 'Collaborative list',
    noItemsYet: 'No Items Yet',
    thisListNoItems: 'This list doesn\'t have any items.',
    sharedAccess: 'Shared Access',
    member: 'Member',
    failedToLoadDetails: 'Failed to Load Details',
    unableToLoadDetails: 'Unable to load list details. Please try again.',
    retry: 'Retry',
    close: 'Close',
    created: 'Created',
    private: 'Private',
    
    // List management (Admin)
    listManagement: 'List Management',
    listManagementDescription: 'Monitor all lists and their usage patterns.',
    hideLists: 'Hide Lists',
    viewLists: 'View Lists',
    hideStats: 'Hide Stats',
    
    // User management (Admin)
    hideUsers: 'Hide Users',
    allUsers: 'All Users',
    searchUsers: 'Search users...',
    noUsersFound: 'No users found matching your search.',
    noUsers: 'No users found.',
    removeAdmin: 'Remove Admin',
    makeAdmin: 'Make Admin',
    deleteUser: 'Delete',
    currentUser: '(Current User)',
    failedToLoadUsers: 'Failed to load users. Please try again.',
    userUpdated: 'User updated successfully.',
    failedToUpdateUser: 'Failed to update user. Please try again.',
    confirmDeleteUser: 'Are you sure you want to delete user "{0}"? This action cannot be undone.',
    userDeleted: 'User deleted successfully.',
    failedToDeleteUser: 'Failed to delete user. Please try again.',
    blockUser: 'Block User',
    unblockUser: 'Unblock User',
    confirmToggleBlocked: 'Are you sure you want to {0} "{1}"?',
    updateUserStatus: 'Update User Status',
    
    // Categories management
    categoriesLabel: 'Categories',
    customCategories: 'Custom Categories',
    categoriesDescription: 'Organize your items with categories. Add new ones or delete categories you don\'t use.',
    defaultCategories: 'Default Categories',
    defaultCategoriesDescription: 'Built-in categories available for all users.',
    customCategoriesDescription: 'Your personal categories for better organization.',
    default: 'Default',
    addNewCategory: 'Type new category name...',
    addCategory: 'Add Category',
    deleteCategory: 'Delete Category',
    hideCategory: 'Hide Category',
    showCategory: 'Show Category',
    confirmDeleteCategory: 'Are you sure you want to delete this category?',
    failedToAddCategory: 'Failed to add category. Please try again.',
    failedToDeleteCategory: 'Failed to delete category. Please try again.',
    failedToUpdateCategory: 'Failed to update category. Please try again.',
    noCustomCategories: 'No custom categories yet',
    addCustomCategoriesHint: 'Create categories that match your shopping style',
    hiddenCategories: 'hidden categories',
    showAll: 'Show All',
    
    // Language settings
    uiLanguage: 'Interface Language',
    uiLanguageDescription: 'Language for buttons, menus, and interface',
    contentLanguage: 'Content Language',
    contentLanguageDescription: 'Language for items, categories, and suggestions',
    
    // Notifications
    notificationSettingsDescription: 'Configure how you want to be notified about list changes and updates.',
    notificationMethods: 'Notification Methods',
    notificationMethodsDescription: 'Choose how you want to receive notifications',
    inAppNotifications: 'In-App Notifications',
    inAppNotificationsDesc: 'Show notifications while using the app',
    pushNotifications: 'Push Notifications',
    pushNotificationsDesc: 'Browser notifications even when app is closed',
    emailNotifications: 'Email Notifications',
    emailNotificationsDesc: 'Receive updates via email',
    notificationTypes: 'What to Notify About',
    notificationTypesDescription: 'Choose which events trigger notifications',
    listSharedNotifications: 'List Shared',
    listSharedNotificationsDescription: 'When someone shares a list with you',
    listUpdatedNotifications: 'List Updated',
    listUpdatedNotificationsDescription: 'When shared lists are modified',
    itemAddedNotifications: 'Items Added',
    itemAddedNotificationsDescription: 'When new items are added to shared lists',
    itemCompletedNotifications: 'Items Completed',
    itemCompletedNotificationsDescription: 'When items are marked as completed',
    notificationPreview: 'Notification Preview',
    notificationPreviewDescription: 'See how notifications will look',
    testNotification: 'Test Notification',
    testAllNotifications: 'Test All Notifications',
    enableInAppFirst: 'Please enable in-app notifications first to test.',
    notificationsDisabled: 'Notifications Disabled',
    testListShared: 'John shared "Grocery List" with you',
    testListUpdated: 'Mary updated "Weekend Plans" - 2 new items added',
    testItemAdded: 'New item "Milk" was added to "Grocery List"',
    testItemCompleted: 'Sarah completed "Buy groceries" in "Weekend Plans"',
    test: 'Test',
    pushNotificationsDenied: 'Push notifications permission was denied. Please enable it in your browser settings.',
    permissionDenied: 'Permission Denied',
    
    // Data and Privacy
    dataAndPrivacyDescription: 'Manage your data and privacy settings.',
    exportData: 'Export Data',
    exportDataDescription: 'Download a copy of your lists and data.',
    exportMyData: 'Export My Data',
    deleteAccount: 'Delete Account',
    deleteAccountDescription: 'Permanently delete your account and all associated data.',
    deleteMyAccount: 'Delete My Account',
    deleteAccountWarning: '⚠️ DANGER: Delete Account\n\nThis action will PERMANENTLY delete:\n\n• All your lists and items\n• Your account profile and settings\n• All shared lists and collaborations\n• All personal data and preferences\n\n🚨 THIS CANNOT BE UNDONE!\n\nAre you absolutely sure you want to continue?',
    finalDeleteConfirmation: 'Final Confirmation',
    typeDeleteToConfirm: 'To confirm account deletion, please type "DELETE" in the field below:',
    deleteConfirmationMismatch: 'You must type "DELETE" exactly to confirm account deletion.',
    confirmationRequired: 'Confirmation Required',
    accountDeleted: 'Account Deleted',
    accountDeletedSuccess: 'Your account has been successfully deleted. You will be redirected to the login page.',
    deleteAccountError: 'Failed to delete account: {error}',
    deletionFailed: 'Deletion Failed',
    deleting: 'Deleting...',
    dataManagement: 'Data Management',
    dataRetention: 'Data Retention',
    dataRetentionDescription: 'Control how long your account is kept when inactive.',
    oneYear: '1 Year',
    twoYears: '2 Years',
    indefinite: 'Indefinite',
    
    // Data Retention Preferences
    dataRetentionPreference: 'Data Retention Preference',
    dataRetentionPreferenceDescription: 'Choose how long to keep your account and data if you become inactive.',
    oneYearRetention: 'Delete my data after 1 year of inactivity',
    twoYearsRetention: 'Delete my data after 2 years of inactivity',
    indefiniteRetention: 'Keep my data indefinitely (never auto-delete)',
    oneYearDescription: 'Your account and all lists will be permanently deleted if you don\'t log in for 1 year.',
    twoYearsDescription: 'Your account and all lists will be permanently deleted if you don\'t log in for 2 years.',
    indefiniteDescription: 'Your data will never be automatically deleted due to inactivity. Only manual deletion is possible.',
    lastLoginLabel: 'Last Login',
    currentRetentionLabel: 'Current Setting',
    retentionPreferenceUpdated: 'Data retention preference updated successfully.',
    retentionPreferenceUpdateFailed: 'Failed to update retention preference. Please try again.',
    privacySettings: 'Privacy Settings',
    privacyGuarantee: 'Your Privacy is Our Priority',
    privacyDescription: 'ListWiz is a safe space that respects your privacy. All settings below start OFF and nothing is shared without your explicit consent. You have complete control over your data.',
    updatingPrivacySettings: 'Updating privacy settings...',
    privacySettingUpdateFailed: 'Failed to update privacy setting. Please try again.',
    profileVisibility: 'Profile Visibility',
    profileVisibilityDescription: 'Allow other users to see your name when you share lists. When OFF, you appear as "Anonymous User" in shared lists.',
    dataSharing: 'Anonymous Usage Data',
    dataSharingDescription: 'Help improve ListWiz by sharing completely anonymous usage statistics. No personal data, list contents, or identifying information is ever shared.',
    analyticsOptIn: 'Analytics & Insights',
    analyticsOptInDescription: 'Receive anonymized insights about your list usage patterns. This data never leaves your device and helps you understand your shopping habits.',
    marketingEmails: 'Feature Updates',
    marketingEmailsDescription: 'Receive occasional emails about new features and improvements. No spam, no third-party emails, and you can unsubscribe anytime.',
    activityLogging: 'Activity Logging',
    activityLoggingDescription: 'Keep a private log of your list activities for troubleshooting and data recovery. Logs are encrypted and only accessible by you.',
    ourCommitment: 'Our Privacy Commitment',
    noSelling: 'We never sell your data',
    noTracking: 'No cross-site tracking',
    localFirst: 'Your data stays on your device when possible',
    encryptedStorage: 'All data is encrypted',
    rightToDelete: 'Full right to delete your data anytime',
    on: 'ON',
    off: 'OFF',
    dangerZone: 'Danger Zone',
    exporting: 'Exporting...',
    exportSuccess: 'Your data has been exported successfully! File: {filename}',
    exportComplete: 'Export Complete',
    exportError: 'Failed to export data: {error}',
    exportFailed: 'Export Failed',
    
    // Admin
    adminDescription: 'Administrator tools and system management.',
    userManagement: 'User Management',
    userManagementDescription: 'View and manage all users in the system.',
    manageUsers: 'Manage Users',
    systemStats: 'System Statistics',
    systemStatsDescription: 'View overall system usage and statistics.',
    viewStats: 'View Stats',
    
    // Admin Panel - Dashboard
    dashboard: 'Dashboard',
    users: 'Users',
    lists: 'Lists',
    dataRetention: 'Data Retention',
    totalUsers: 'Total Users',
    shoppingLists: 'Lists',
    completionRate: 'Completion Rate',
    shares: 'Shares',
    itemsChecked: 'Items Checked',
    activeUsers: 'active users',
    avgPerUser: 'avg per user',
    completed: 'completed',
    activeListShares: 'Active list shares',
    lifetimeTotal: 'Lifetime total',
    recentActivity: 'Recent Activity',
    newUsers: 'new users',
    newLists: 'new lists',
    newItems: 'new items',
    days: 'days',
    insights: 'Insights',
    mostProductive: 'Most productive',
    itemsCheckedCount: 'items checked',
    topCategory: 'Top category',
    items: 'items',
    
    // Admin Panel - Error States
    failedToLoadAdminData: 'Failed to load admin data. Please try again.',
    noDataAvailable: 'No data available',
    loadingAdminData: 'Loading admin data...',
    
    // Admin Panel - List Management
    confirmToggleListBlock: 'Are you sure you want to {0} "{1}"?',
    confirmDeleteListAdmin: 'Are you sure you want to permanently delete "{0}"? This action cannot be undone and will delete all items in the list.',
    listNotFound: 'List not found',
    listBlockedSuccessfully: 'List "{0}" has been {1} successfully.',
    listDeletedSuccessfully: 'List "{0}" has been deleted successfully.',
    failedToToggleListBlock: 'Failed to {0} list. Please try again.',
    failedToDeleteList: 'Failed to delete list. Please try again.',
    failedToLoadListDetails: 'Failed to load list details. Please try again.',
    blockList: 'Block List',
    unblockList: 'Unblock List',
    deleteList: 'Delete List',
    transferOwnership: 'Transfer Ownership',
    editList: 'Edit List',
    listEditingComingSoon: 'List editing - coming soon!',
    transferOwnershipComingSoon: 'Transfer ownership - coming soon!',
    
    // Transfer Ownership Modal
    listToTransfer: 'List to transfer',
    importantNotice: 'Important Notice',
    transferOwnershipWarning: 'Once ownership is transferred, the current owner will no longer own this list. The current owner will be granted write access to continue collaborating.',
    selectNewOwner: 'Select New Owner',
    searchByEmail: 'Search by name or email address...',
    searchingUsers: 'Searching users...',
    searchResults: 'Search Results',
    noUsersFound: 'No users found with that email',
    newOwnerPreview: 'New Owner',
    pleaseSelectUser: 'Please select a user',
    failedToSearchUsers: 'Failed to search users',
    failedToTransferOwnership: 'Failed to transfer ownership',
    transferring: 'Transferring...',
    ownershipTransferredSuccessfully: 'List ownership has been transferred to {0} successfully.',
    
    block: 'block',
    unblock: 'unblock',
    blocked: 'blocked',
    unblocked: 'unblocked',
    
    // List Management UI Text
    viewList: 'View List',
    listDetails: 'List Details',
    listOverview: 'List Overview',
    listItems: 'List Items',
    sharedWith: 'Shared With',
    private: 'Private',
    public: 'Public',
    createdBy: 'Created By',
    lastModified: 'Last Modified',
    itemCount: 'Item Count',
    completedItems: 'Completed Items',
    pendingItems: 'Pending Items',
    noSharedUsers: 'No shared users',
    sharedUsers: 'Shared Users',
    listOwner: 'List Owner',
    
    // Profile UI Text
    accountSettings: 'Account Settings',
    managePersonalInformation: 'Manage your personal information',
    displayName: 'Display Name',
    emailAddress: 'Email Address',
    accountStatus: 'Account Status',
    active: 'Active',
    yourActivity: 'Your Activity',
    shoppingInsights: 'Shopping insights & progress',
    startShoppingJourney: 'Start Your Shopping Journey!',
    createFirstListPrompt: 'Create your first list to see your activity stats here.',
    createYourFirstList: 'Create Your First List',
    shoppingLists: 'Lists',
    shared: 'shared',
    totalItems: 'Total Items',
    completed: 'completed',
    avgProgress: 'Avg. Progress',
    efficiencyScore: 'efficiency score',
    editProfile: 'Edit Profile',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    cancel: 'Cancel',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    
    // Statistics
    statisticsOverview: 'Statistics Overview',
    myLists: 'My Lists',
    totalItems: 'Total Items',
    itemsChecked: 'Items Checked',
    sharedWithMe: 'Shared With Me',
    achievements: 'Achievements',
    averageProgress: 'Average Progress',
    itemsPerList: 'Items per List',
    mostProductiveList: 'Most Productive List',
    
    // List management
    myShoppingLists: 'My Lists',
    newList: 'New List',
    createList: 'Create List',
    createNewList: 'Create New List',
    listName: 'List Name',
    listNameRequired: 'List Name *',
    description: 'Description (Optional)',
    listNamePlaceholder: 'e.g., Weekly Groceries, Party Supplies...',
    descriptionPlaceholder: 'Add a description to help organize your list...',
    cancel: 'Cancel',
    creating: 'Creating...',
    enterListName: 'Enter list name...',
    enterDescription: 'Enter description (optional)...',
    
    // Items
    addItem: 'Add Item',
    addNewItem: 'Add New Item',
    enterItemName: 'Enter item name...',
    enterQuantity: 'Enter quantity...',
    enterNotes: 'Enter notes...',
    selectCategory: 'Select category...',
    searchItems: 'Search items...',
    of: 'of',
    itemsCompleted: 'items completed',
    
    // Item list states
    noItemsFound: 'No items found',
    noItemsMatch: 'No items match',
    addFirstItem: 'Start by adding your first item to this list!',
    addFirstItemBtn: 'Add First Item',
    
    // Filter tabs
    all: 'All',
    pending: 'Pending',
    bought: 'Bought',
    
    // List actions
    expandHeader: 'Expand header',
    collapseHeader: 'Collapse header',
    uncheckAll: 'Uncheck All',
    clearChecked: 'Clear Checked Items',
    clearAllItems: 'Clear All Items',
    confirmClearAll: 'Are you sure you want to clear all items from this list?',
    confirmClearChecked: 'Are you sure you want to clear all checked items from this list?',
    confirmUncheckAll: 'Are you sure you want to uncheck all items in this list?',
    itemsClearedAll: 'All items have been cleared from the list.',
    itemsClearedChecked: 'All checked items have been cleared from the list.',
    itemsUnchecked: 'All items have been unchecked.',
    
    // List actions
    shareList: 'Share List',
    shareWith: 'Share with...',
    enterEmail: 'Enter email...',
    addPeople: 'Add People',
    emailAddress: 'Email Address',
    enterEmailAddress: 'Enter email address',
    searching: 'Searching...',
    permission: 'Permission',
    editAndAddItems: 'Edit & Add Items',
    canEdit: 'Can Edit',
    sharing: 'Sharing...',
    peopleWithAccess: 'People with Access',
    changePermission: 'Change permission',
    removeAccess: 'Remove access',
    confirmRemoveAccess: 'Remove access for {0}?',
    accessRemoved: 'Access removed for {0}',
    permissionUpdated: 'Permission updated for {0}',
    failedToRemoveAccess: 'Failed to remove access',
    failedToUpdatePermission: 'Failed to update permission',
    shareWithUser: 'Share with User',
    listShared: 'List shared successfully!',
    shareListFailed: 'Failed to share list. Please try again.',
    deleteList: 'Delete List',
    confirmDeleteList: 'Are you sure you want to delete this list?',
    listDeleted: 'List deleted successfully.',
    removeDefault: 'Remove Default',
    setAsDefault: 'Set as Default',
    sharedBy: 'Shared by',
    unfollow: 'Unfollow',
    confirmUnfollow: 'Are you sure you want to stop following this list?',
    unfollowSuccess: 'Successfully unfollowed list',
    updated: 'Updated',
    
    // Messages
    noItemsYet: 'No items in this list yet.',
    noListsYet: 'No lists yet. Create your first list!',
    listCreated: 'List created successfully!',
    listUpdated: 'List updated successfully!',
    itemAdded: 'Item added successfully!',
    itemUpdated: 'Item updated successfully!',
    itemDeleted: 'Item deleted successfully!',
    duplicateItemWarning: 'This item already exists in the list.',
    
    // Errors
    errorLoadingLists: 'Error loading lists. Please try again.',
    errorLoadingList: 'Error loading list. Please try again.',
    errorCreatingList: 'Failed to create list. Please try again.',
    errorUpdatingList: 'Failed to update list. Please try again.',
    errorDeletingList: 'Failed to delete list. Please try again.',
    errorAddingItem: 'Failed to add item. Please try again.',
    errorUpdatingItem: 'Failed to update item. Please try again.',
    errorDeletingItem: 'Failed to delete item. Please try again.',
    networkError: 'Network error. Please check your connection.',
    
    // Progress and completion
    progress: 'Progress',
    completionRate: 'Completion Rate',
    allItemsChecked: 'All items checked!',
    listCompleted: 'List completed!',
    
    // Quick actions
    quickActions: 'Quick Actions',
    markAllComplete: 'Mark All Complete',
    clearCompleted: 'Clear Completed',
    sortByCategory: 'Sort by Category',
    sortByName: 'Sort by Name',
    
    // Recent Items Modal
    recentItems: 'Recent Items',
    recent: 'Recent',
    searchItems: 'Search items...',
    noItemsFound: 'No items found',
    noRecentItems: 'No recent items',
    category: 'Category',
    general: 'General',
    selectCategory: 'Select Category',
    editCategory: 'Edit Category',
    added: 'Added',
    deleteItem: 'Delete Item',
    confirmDelete: 'Confirm Delete',
    confirmDeleteItem: 'Are you sure you want to delete this item?',
    errorUpdatingCategory: 'Error updating category',
    errorDeletingItem: 'Error deleting item',
    
    // Enhanced Recent Items Modal
    statistics: 'Statistics',
    totalItems: 'Total Items',
    categories: 'Categories',
    mostUsedCategory: 'Most Used Category',
    showStats: 'Show Statistics',
    bulkMode: 'Bulk',
    bulkSelectionMode: 'Bulk Selection Mode',
    name: 'Name',
    selectAll: 'Select All',
    clearSelection: 'Clear',
    selected: 'selected',
    addSelected: 'Add Selected to List',
    deleteSelected: 'Delete Selected',
    addToList: 'Add to List',
    errorAddingItem: 'Error adding item to list',
    errorBulkDelete: 'Error deleting selected items',
    errorBulkAdd: 'Error adding selected items',
    lastUsed: 'Last used',
    
    // Compact Recent Items Modal - New Translations
    sortByRecent: 'Most Recent',
    sortByName: 'Name',
    sortByFrequency: 'Most Used',
    sortByCategory: 'Category',
    itemsSelected: 'items selected',
    
    // Smart Seed Modal
    smartSeedDatabase: 'Smart Seed Database',
    selectContentLanguage: 'Select Content Language',
    chooseContentLanguageDesc: 'Choose the language for your list items (independent of UI language)',
    chooseTemplateType: 'Choose Template Type',
    selectTemplateDesc: 'Select what kind of list you want to create',
    categoryMapping: 'Category Mapping',
    categoryMappingDesc: 'Map template categories to your existing categories or create new ones',
    seedingDatabaseWith: 'Seeding database with:',
    createNewCategory: '✨ Create new category',
    useExistingCategory: '📁 Use "{0}"',
    noExistingCategories: 'No existing categories found',
    newCategoriesToCreate: 'New categories to be created:',
    seedingDatabase: 'Seeding Database...',
    seedDatabase: 'Seed Database',
    seedingComplete: 'Seeding Complete!',
    seedingSuccessMessage: 'Successfully added items to your database for better autocomplete suggestions.',
    quickTip: '💡 Quick Tip',
    quickAddTipMessage: 'All these items are now available in Quick Add! When adding items to any list, you\'ll see better autocomplete suggestions based on what you just seeded.',
    done: 'Done',
    stepOf: 'Step {0} of {1}',
    complete: 'Complete',
    seedingError: 'Failed to seed items into database. Please try again.'
  },
  
  no: {
    // App title and basic labels
    appName: 'ListWiz',
    appDescription: 'Opprett, del og administrer listene dine med letthet',
    
    // Common actions
    add: 'Legg til',
    edit: 'Rediger',
    delete: 'Slett',
    save: 'Lagre',
    cancel: 'Avbryt',
    update: 'Oppdater',
    share: 'Del',
    close: 'Lukk',
    confirm: 'Bekreft',
    alert: 'Varsel',
    loading: 'Laster...',
    back: 'Tilbake',
    quickAdd: 'Hurtig legg til',
    customize: 'Tilpass',
    quickAddSettings: 'Hurtig Legg til Innstillinger',
    maxItems: 'Antall elementer',
    disabled: 'Deaktivert',
    autoGenerate: 'Auto-generer fra handlehistorikken din',
    quickAddInfo: 'Hurtig legg til elementer er basert på det du vanligvis legger til denne spesifikke listen.',
    manageItems: 'Administrer Elementer Manuelt',
    manageQuickAdd: 'Administrer Hurtig Legg til Elementer',
    addQuickItem: 'Skriv varens navn, kategori...',
    addNewQuickItem: 'Legg til Nytt Hurtig Element',
    itemName: 'Elementnavn',
    currentQuickItems: 'Gjeldende Hurtig Elementer',
    noQuickItems: 'Ingen hurtig legg til elementer konfigurert.',
    quickItemsHelp: 'Legg til elementer ovenfor for å opprette din tilpassede hurtig legg til liste.',
    quickAddManagerInfo: 'Disse elementene vil vises som hurtig-legg til knapper for denne spesifikke listen. Du kan dra for å endre rekkefølge.',
    saveChanges: 'Lagre Endringer',
    saving: 'Lagrer...',
    errorSaving: 'Feil ved lagring av endringer. Vennligst prøv igjen.',
    
    // Manage suggestions
    manageSuggestions: 'Administrer Forslag',
    manageSuggestionsDesc: 'Gå gjennom og slett uønskede forslag fra handlehistorikken din',
    searchSuggestions: 'Søk i forslag...',
    show: 'Vis',
    allItems: 'Alle elementer',
    unused: 'Ubrukte (30+ dager)',
    recent: 'Nylige (7 dager)',
    sortBy: 'Sorter etter',
    frequency: 'Frekvens',
    lastUsed: 'Sist brukt',
    name: 'Navn',
    selectAll: 'Velg alle',
    deselectAll: 'Fjern valg alle',
    deleteSelected: 'Slett valgte',
    noSuggestions: 'Ingen forslag funnet',
    noSuggestionsDesc: 'Prøv å justere søk eller filtre.',
    deleteItem: 'Slett dette forslaget',
    totalSuggestions: 'Totale forslag',
    showing: 'Viser',
    
    // Basic terms
    lists: 'Lister',
    days: 'Dager',
    items: 'Elementer', 
    administrator: 'Administrator',
    member: 'Medlem',
    joined: 'Ble med',
    notAvailable: 'Ikke tilgjengelig',
    
    // Error messages
    networkErrorBackendNotRunning: 'Nettverksfeil - backend kjører muligens ikke',
    
    // Time formatting
    oneDay: '1 dag',
    daysCount: '{0} dager',
    monthsCount: '{0} måneder',
    yearsCount: '{0} år',
    
    // Shopping list terms
    items: 'elementer',
    checked: 'avkrysset',
    complete: 'Ferdig',
    active: 'Aktiv',
    empty: 'Tom',
    
    // Categories
    categories: {
      'General': 'Generelt',
      'Groceries': 'Dagligvarer',
      'Household': 'Husholdning',
      'Personal Care': 'Personlig pleie',
      'Health & Beauty': 'Helse og skjønnhet',
      'Electronics': 'Elektronikk',
      'Clothing': 'Klær',
      'Books': 'Bøker',
      'Health': 'Helse',
      'Pharmacy': 'Apotek',
      'Hardware': 'Verktøy'
    },
    
    // Form labels
    welcomeBack: 'Velkommen tilbake',
    appSlogan: 'Smarte Lister Gjort Enkelt',
    createFirstList: 'Start med å opprette din første liste. Organiser, del og glem aldri et element igjen!',
    listName: 'Listenavn',
    description: 'Beskrivelse',
    itemName: 'Elementnavn',
    quantity: 'Antall',
    category: 'Kategori',
    notes: 'Notater',
    optional: 'Valgfri',
    done: 'Ferdig',
    adding: 'Legger til...',
    quickAdd: 'Hurtig Legg til',
    
    // Authentication
    login: 'Logg inn',
    register: 'Registrer',
    logout: 'Logg ut',
    email: 'E-post',
    password: 'Passord',
    name: 'Navn',
    confirmPassword: 'Bekreft passord',
    loginFailed: 'Innlogging mislyktes. Sjekk innloggingsdetaljene dine.',
    registrationFailed: 'Registrering mislyktes. Prøv igjen.',
    registrationSuccess: 'Konto opprettet! Logg inn.',
    emailExists: 'En konto med denne e-posten eksisterer allerede.',
    
    // Settings and Profile
    settings: 'Innstillinger',
    settingsDescription: 'Tilpass din ListWiz-opplevelse',
    profile: 'Profil',
    profileDescription: 'Administrer kontoinformasjon og preferanser.',
    statistics: 'Statistikk',
    statisticsDescription: 'Din handleaktivitet og prestasjoner.',
    languages: 'Språk',
    languageDescription: 'Angi språkpreferanser for grensesnitt og innhold.',
    notifications: 'Varsler',
    dataAndPrivacy: 'Data og personvern',
    administration: 'Administrasjon',
    personalInformation: 'Personlig informasjon',
    personalInformationDescription: 'Oppdater navn og passord.',
    editProfile: 'Rediger profil',
    saveChanges: 'Lagre endringer',
    saving: 'Lagrer...',
    changePassword: 'Endre passord',
    changePasswordDescription: 'Slå på for å endre passordet ditt',
    currentPassword: 'Nåværende passord',
    enterCurrentPassword: 'Skriv inn nåværende passord',
    newPassword: 'Nytt passord',
    enterName: 'Skriv inn navnet ditt',
    enterNewPassword: 'Skriv inn nytt passord',
    confirmNewPassword: 'Bekreft nytt passord',
    nameRequired: 'Navn er påkrevd.',
    oldPasswordRequired: 'Nåværende passord er påkrevd for å endre passord.',
    newPasswordRequired: 'Nytt passord er påkrevd.',
    passwordTooShort: 'Nytt passord må være minst 6 tegn langt.',
    passwordsDoNotMatch: 'Nye passord stemmer ikke overens.',
    profileUpdated: 'Profil oppdatert.',
    profileUpdateFailed: 'Kunne ikke oppdatere profil. Prøv igjen.',
    memberSince: 'Medlem siden',
    administrator: 'Administrator',
    unknown: 'Ukjent',
    success: 'Suksess',
    error: 'Feil',
    info: 'Info',
    
    // Category management - missing keys
    categoryAlreadyExists: 'Kategorien "{0}" eksisterer allerede.',
    duplicateCategory: 'Duplikat kategori',
    confirmDelete: 'Bekreft sletting',
    standardCategory: 'Standard',
    customCategory: 'Tilpasset',
    yourCategories: 'Dine kategorier',
    categoryNamePlaceholder: 'Skriv inn kategorinavn...',
    noCategories: 'Ingen kategorier ennå',
    emptyCategoriesHint: 'Start med å opprette din første kategori ovenfor. Kategorier hjelper deg med å organisere listeelementene effektivt.',
    createCategoryHint: 'Opprett egne kategorier for listene dine',
    noCategoryFallback: 'Ingen Kategori',
    
    // Admin management - missing keys
    loadingAdminData: 'Laster administratordata...',
    user: 'Bruker',
    joined: 'Ble med',
    actions: 'Handlinger',
    owned: 'eiet',
    shared: 'delt',
    confirmDeleteUser: 'Er du sikker på at du vil slette bruker "{0}" ({1})? Dette vil også slette alle deres lister og data.',
    confirmToggleAdmin: 'Er du sikker på at du vil {0} "{1}"?',
    confirmToggleBlocked: 'Er du sikker på at du vil {0} "{1}"?',
    updateUserRole: 'Oppdater brukerrolle',
    updateUserStatus: 'Oppdater brukerstatus',
    userNotFound: 'Bruker ikke funnet. Brukerlisten har blitt oppdatert.',
    failedToLoadAdminData: 'Kunne ikke laste administratordata. Prøv igjen.',
    
    // Admin User Management
    totalUsers: 'Totalt antall brukere',
    administrators: 'Administratorer',
    blockedUsers: 'Blokkerte brukere',
    users: 'Brukere',
    searchUsers: 'Søk brukere...',
    allUsers: 'Alle brukere',
    activeUsers: 'Aktive',
    showingUsers: 'Viser {0}-{1} av {2} brukere',
    previous: 'Forrige',
    next: 'Neste',
    show: 'Vis',
    
    // Admin System Stats
    totalLists: 'Totalt antall lister',
    totalItems: 'Totalt antall elementer',
    completionRate: 'Fullføringsgrad',
    withLists: 'med lister',
    avgPerUser: 'gj.snitt per bruker',
    completed: 'fullført',
    systemAverage: 'Systemgjennomsnitt',
    systemHealth: 'Systemhelse',
    uptime: 'Oppetid',
    memory: 'Minne',
    
    // Admin List Management
    searchLists: 'Søk lister...',
    total: 'Totalt',
    shared: 'Delt',
    by: 'av',
    items: 'elementer',
    private: 'Privat',
    viewListDetails: 'Vis listedetaljer',
    editList: 'Rediger liste',
    unblockList: 'Opphev blokkering av liste',
    blockList: 'Blokker liste',
    transferOwnership: 'Overfør eierskap',
    deleteList: 'Slett liste',
    showingLists: 'Viser {0}-{1} av {2} lister',
    // View List Modal
    loadingListDetails: 'Laster listedetaljer...',
    overview: 'Oversikt',
    owner: 'Eier',
    created: 'Opprettet',
    totalItems: 'Totalt antall elementer',
    completed: 'Fullført',
    shared: 'Delt',
    users: 'brukere',
    progress: 'Fremgang',
    items: 'Elementer',
    viewOnly: 'Kun visning',
    collaborative: 'Samarbeid',
    sharedList: 'Delt liste',
    defaultList: 'Standardliste',
    collaborativeList: 'Samarbeidsliste',
    noItemsYet: 'Ingen elementer ennå',
    thisListNoItems: 'Denne listen har ingen elementer.',
    sharedAccess: 'Delt tilgang',
    member: 'Medlem',
    failedToLoadDetails: 'Kunne ikke laste detaljer',
    unableToLoadDetails: 'Kunne ikke laste listedetaljer. Prøv igjen.',
    retry: 'Prøv igjen',
    close: 'Lukk',
    listManagement: 'Listeadministrasjon',
    listManagementDescription: 'Administrer alle lister i systemet.',
    hideLists: 'Skjul lister',
    viewLists: 'Vis lister',
    hideStats: 'Skjul statistikk',
    shoppingLists: 'Lister',
    listName: 'Listenavn',
    owner: 'Eier',
    sharedWith: 'Delt med',
    created: 'Opprettet',
    private: 'Privat',
    
    // User management (Admin)
    hideUsers: 'Skjul brukere',
    allUsers: 'Alle brukere',
    searchUsers: 'Søk brukere...',
    noUsersFound: 'Ingen brukere funnet som matcher søket.',
    noUsers: 'Ingen brukere funnet.',
    removeAdmin: 'Fjern admin',
    makeAdmin: 'Gjør til admin',
    deleteUser: 'Slett',
    currentUser: '(Nåværende bruker)',
    failedToLoadUsers: 'Kunne ikke laste brukere. Prøv igjen.',
    userUpdated: 'Bruker oppdatert.',
    failedToUpdateUser: 'Kunne ikke oppdatere bruker. Prøv igjen.',
    confirmDeleteUser: 'Er du sikker på at du vil slette bruker "{0}"? Denne handlingen kan ikke angres.',
    userDeleted: 'Bruker slettet.',
    failedToDeleteUser: 'Kunne ikke slette bruker. Prøv igjen.',
    blockUser: 'Blokker bruker',
    unblockUser: 'Fjern blokkering',
    confirmToggleBlocked: 'Er du sikker på at du vil {0} "{1}"?',
    updateUserStatus: 'Oppdater brukerstatus',
    
    // Categories management
    categoriesLabel: 'Kategorier',
    customCategories: 'Egendefinerte kategorier',
    categoriesDescription: 'Organiser elementene dine med kategorier. Legg til nye eller slett kategorier du ikke bruker.',
    defaultCategories: 'Standard kategorier',
    defaultCategoriesDescription: 'Innebygde kategorier tilgjengelig for alle brukere.',
    customCategoriesDescription: 'Dine personlige kategorier for bedre organisering.',
    default: 'Standard',
    addNewCategory: 'Skriv inn nytt kategorinavn...',
    addCategory: 'Legg til kategori',
    deleteCategory: 'Slett kategori',
    hideCategory: 'Skjul kategori',
    showCategory: 'Vis kategori',
    confirmDeleteCategory: 'Er du sikker på at du vil slette denne kategorien?',
    failedToAddCategory: 'Kunne ikke legge til kategori. Prøv igjen.',
    failedToDeleteCategory: 'Kunne ikke slette kategori. Prøv igjen.',
    failedToUpdateCategory: 'Kunne ikke oppdatere kategori. Prøv igjen.',
    noCustomCategories: 'Ingen egendefinerte kategorier ennå',
    addCustomCategoriesHint: 'Lag kategorier som passer din handlestyle',
    hiddenCategories: 'skjulte kategorier',
    showAll: 'Vis alle',
    
    // Language settings
    uiLanguage: 'Grensesnittspråk',
    uiLanguageDescription: 'Språk for knapper, menyer og grensesnitt',
    contentLanguage: 'Innholdsspråk',
    contentLanguageDescription: 'Språk for elementer, kategorier og forslag',
    
    // Notifications
    notificationSettingsDescription: 'Konfigurer hvordan du vil bli varslet om listeendringer og oppdateringer.',
    notificationMethods: 'Varslingsmetoder',
    notificationMethodsDescription: 'Velg hvordan du vil motta varsler',
    inAppNotifications: 'App-varsler',
    inAppNotificationsDesc: 'Vis varsler mens du bruker appen',
    pushNotifications: 'Push-varsler',
    pushNotificationsDesc: 'Nettlesivarsler selv når appen er lukket',
    emailNotifications: 'E-postvarsler',
    emailNotificationsDesc: 'Motta oppdateringer via e-post',
    notificationTypes: 'Hva du skal varsles om',
    notificationTypesDescription: 'Velg hvilke hendelser som utløser varsler',
    listSharedNotifications: 'Liste delt',
    listSharedNotificationsDescription: 'Når noen deler en liste med deg',
    listUpdatedNotifications: 'Liste oppdatert',
    listUpdatedNotificationsDescription: 'Når delte lister endres',
    itemAddedNotifications: 'Elementer lagt til',
    itemAddedNotificationsDescription: 'Når nye elementer legges til i delte lister',
    itemCompletedNotifications: 'Elementer fullført',
    itemCompletedNotificationsDescription: 'Når elementer markeres som fullført',
    notificationPreview: 'Forhåndsvisning av varsler',
    notificationPreviewDescription: 'Se hvordan varsler vil se ut',
    testNotification: 'Test varsel',
    testAllNotifications: 'Test alle varsler',
    enableInAppFirst: 'Aktiver først app-varsler for å teste.',
    notificationsDisabled: 'Varsler deaktivert',
    testListShared: 'John delte "Liste" med deg',
    testListUpdated: 'Mary oppdaterte "Helgeplaner" - 2 nye elementer lagt til',
    testItemAdded: 'Nytt element "Melk" ble lagt til i "Liste"',
    testItemCompleted: 'Sarah fullførte "Kjøp mat" i "Helgeplaner"',
    test: 'Test',
    pushNotificationsDenied: 'Tillatelse for push-varsler ble avvist. Aktiver det i nettleserinnstillingene.',
    permissionDenied: 'Tillatelse avvist',
    
    // Data and Privacy
    dataAndPrivacyDescription: 'Administrer data- og personverninnstillinger.',
    exportData: 'Eksporter data',
    exportDataDescription: 'Last ned en kopi av listene og dataene dine.',
    exportMyData: 'Eksporter mine data',
    deleteAccount: 'Slett konto',
    deleteAccountDescription: 'Slett kontoen din og alle tilhørende data permanent.',
    deleteMyAccount: 'Slett min konto',
    deleteAccountWarning: '⚠️ FARE: Slett konto\n\nDenne handlingen vil PERMANENT slette:\n\n• Alle dine lister og elementer\n• Din kontoprofil og innstillinger\n• Alle delte lister og samarbeid\n• All personlig data og preferanser\n\n🚨 DETTE KAN IKKE ANGRES!\n\nEr du helt sikker på at du vil fortsette?',
    finalDeleteConfirmation: 'Endelig bekreftelse',
    typeDeleteToConfirm: 'For å bekrefte sletting av konto, skriv "DELETE" i feltet nedenfor:',
    deleteConfirmationMismatch: 'Du må skrive "DELETE" nøyaktig for å bekrefte sletting av konto.',
    confirmationRequired: 'Bekreftelse påkrevd',
    accountDeleted: 'Konto slettet',
    accountDeletedSuccess: 'Kontoen din er slettet. Du vil bli omdirigert til påloggingssiden.',
    deleteAccountError: 'Kunne ikke slette konto: {error}',
    deletionFailed: 'Sletting mislyktes',
    deleting: 'Sletter...',
    dataManagement: 'Dataadministrasjon',
    dataRetention: 'Datalagring',
    dataRetentionDescription: 'Kontroller hvor lenge kontoen din oppbevares når den er inaktiv.',
    oneYear: '1 år',
    twoYears: '2 år',
    indefinite: 'På ubestemt tid',
    
    // Data Retention Preferences
    dataRetentionPreference: 'Datalagringsinnstilling',
    dataRetentionPreferenceDescription: 'Velg hvor lenge kontoen og dataene dine skal beholdes hvis du blir inaktiv.',
    oneYearRetention: 'Slett dataene mine etter 1 år med inaktivitet',
    twoYearsRetention: 'Slett dataene mine etter 2 år med inaktivitet',
    indefiniteRetention: 'Behold dataene mine på ubestemt tid (slett aldri automatisk)',
    oneYearDescription: 'Kontoen din og alle lister vil bli permanent slettet hvis du ikke logger inn på 1 år.',
    twoYearsDescription: 'Kontoen din og alle lister vil bli permanent slettet hvis du ikke logger inn på 2 år.',
    indefiniteDescription: 'Dataene dine vil aldri bli automatisk slettet på grunn av inaktivitet. Kun manuell sletting er mulig.',
    lastLoginLabel: 'Siste pålogging',
    currentRetentionLabel: 'Gjeldende innstilling',
    retentionPreferenceUpdated: 'Datalagringsinnstilling oppdatert.',
    retentionPreferenceUpdateFailed: 'Kunne ikke oppdatere lagringsinnstilling. Prøv igjen.',
    privacySettings: 'Personverninnstillinger',
    privacyGuarantee: 'Ditt personvern er vår prioritet',
    privacyDescription: 'ListWiz er et trygt sted som respekterer ditt personvern. Alle innstillinger nedenfor starter AV og ingenting deles uten ditt eksplisitte samtykke. Du har full kontroll over dine data.',
    updatingPrivacySettings: 'Oppdaterer personverninnstillinger...',
    privacySettingUpdateFailed: 'Kunne ikke oppdatere personverninnstilling. Prøv igjen.',
    profileVisibility: 'Profilsynlighet',
    profileVisibilityDescription: 'Tillat andre brukere å se navnet ditt når du deler lister. Når AV, vises du som "Anonym bruker" i delte lister.',
    dataSharing: 'Anonym bruksdata',
    dataSharingDescription: 'Hjelp til med å forbedre ListWiz ved å dele helt anonyme bruksstatistikker. Ingen persondata, listeinnhold eller identifiserende informasjon deles noensinne.',
    analyticsOptIn: 'Analyse og innsikt',
    analyticsOptInDescription: 'Motta anonymiserte innsikter om dine brukersmønstre. Disse dataene forlater aldri enheten din og hjelper deg med å forstå handlevaner.',
    marketingEmails: 'Funksjonsoppdateringer',
    marketingEmailsDescription: 'Motta sporadiske e-poster om nye funksjoner og forbedringer. Ingen spam, ingen tredjepartsmailer, og du kan melde deg av når som helst.',
    activityLogging: 'Aktivitetslogging',
    activityLoggingDescription: 'Hold en privat logg over listeaktivitetene dine for feilsøking og datagjenoppretting. Logger er krypterte og kun tilgjengelige for deg.',
    ourCommitment: 'Vårt personvernløfte',
    noSelling: '🚫 Vi selger aldri dataene dine',
    noTracking: '🔒 Ingen kryssnettstedsporing',
    localFirst: '💾 Dataene dine blir på enheten din når mulig',
    encryptedStorage: '🔐 All data er kryptert',
    rightToDelete: '🗑️ Full rett til å slette dataene dine når som helst',
    on: 'PÅ',
    off: 'AV',
    dangerZone: 'Faresone',
    exporting: 'Eksporterer...',
    exportSuccess: 'Dataene dine er eksportert! Fil: {filename}',
    exportComplete: 'Eksport fullført',
    exportError: 'Kunne ikke eksportere data: {error}',
    exportFailed: 'Eksport mislyktes',
    
    // Admin
    adminDescription: 'Administratorverktøy og systemadministrasjon.',
    userManagement: 'Brukeradministrasjon',
    userManagementDescription: 'Vis og administrer alle brukere i systemet.',
    manageUsers: 'Administrer brukere',
    systemStats: 'Systemstatistikk',
    systemStatsDescription: 'Vis samlet systembruk og statistikk.',
    viewStats: 'Vis statistikk',
    
    // Admin Panel - Dashboard
    dashboard: 'Dashboard',
    users: 'Brukere',
    lists: 'Lister',
    dataRetention: 'Datalagring',
    totalUsers: 'Totalt antall brukere',
    shoppingLists: 'Lister',
    completionRate: 'Fullføringsgrad',
    shares: 'Delinger',
    itemsChecked: 'Elementer avkrysset',
    activeUsers: 'aktive brukere',
    avgPerUser: 'gjennomsnitt per bruker',
    completed: 'fullført',
    activeListShares: 'Aktive listedelte',
    lifetimeTotal: 'Totalt alle tider',
    recentActivity: 'Nylig aktivitet',
    newUsers: 'nye brukere',
    newLists: 'nye lister',
    newItems: 'nye elementer',
    days: 'dager',
    insights: 'Innsikter',
    mostProductive: 'Mest produktive',
    itemsCheckedCount: 'elementer avkrysset',
    topCategory: 'Topp kategori',
    items: 'elementer',
    
    // Admin Panel - Error States
    failedToLoadAdminData: 'Kunne ikke laste admindata. Prøv igjen.',
    noDataAvailable: 'Ingen data tilgjengelig',
    loadingAdminData: 'Laster admindata...',
    
    // Admin Panel - List Management
    confirmToggleListBlock: 'Er du sikker på at du vil {0} "{1}"?',
    confirmDeleteListAdmin: 'Er du sikker på at du vil permanent slette "{0}"? Denne handlingen kan ikke angres og vil slette alle elementer i listen.',
    listNotFound: 'Liste ikke funnet',
    listBlockedSuccessfully: 'Liste "{0}" har blitt {1}.',
    listDeletedSuccessfully: 'Liste "{0}" har blitt slettet.',
    failedToToggleListBlock: 'Kunne ikke {0} liste. Prøv igjen.',
    failedToDeleteList: 'Kunne ikke slette liste. Prøv igjen.',
    failedToLoadListDetails: 'Kunne ikke laste listedetaljer. Prøv igjen.',
    blockList: 'Blokker liste',
    unblockList: 'Opphev blokkering av liste',
    deleteList: 'Slett liste',
    transferOwnership: 'Overfør eierskap',
    editList: 'Rediger liste',
    listEditingComingSoon: 'Listeendring - kommer snart!',
    transferOwnershipComingSoon: 'Overføring av eierskap - kommer snart!',
    
    // Transfer Ownership Modal
    listToTransfer: 'Liste å overføre',
    importantNotice: 'Viktig melding',
    transferOwnershipWarning: 'Når eierskap overføres, vil den nåværende eieren ikke lenger eie denne listen. Den nåværende eieren vil få skrivetilgang for å fortsette å samarbeide.',
    selectNewOwner: 'Velg ny eier',
    searchByEmail: 'Søk etter navn eller e-postadresse...',
    searchingUsers: 'Søker etter brukere...',
    searchResults: 'Søkeresultater',
    noUsersFound: 'Ingen brukere funnet med den e-postadressen',
    newOwnerPreview: 'Ny eier',
    pleaseSelectUser: 'Vennligst velg en bruker',
    failedToSearchUsers: 'Kunne ikke søke etter brukere',
    failedToTransferOwnership: 'Kunne ikke overføre eierskap',
    transferring: 'Overfører...',
    ownershipTransferredSuccessfully: 'Listeeierskap har blitt overført til {0}.',
    
    block: 'blokkere',
    unblock: 'oppheve blokkering',
    blocked: 'blokkert',
    unblocked: 'blokkering opphevet',
    
    // List Management UI Text
    viewList: 'Vis liste',
    listDetails: 'Listedetaljer',
    listOverview: 'Listeoversikt',
    listItems: 'Listeelementer',
    sharedWith: 'Delt med',
    private: 'Privat',
    public: 'Offentlig',
    createdBy: 'Opprettet av',
    lastModified: 'Sist endret',
    itemCount: 'Antall elementer',
    completedItems: 'Fullførte elementer',
    pendingItems: 'Ventende elementer',
    noSharedUsers: 'Ingen delte brukere',
    sharedUsers: 'Delte brukere',
    listOwner: 'Listeeier',
    
    // Profile UI Text
    accountSettings: 'Kontoinnstillinger',
    managePersonalInformation: 'Administrer din personlige informasjon',
    displayName: 'Visningsnavn',
    emailAddress: 'E-postadresse',
    accountStatus: 'Kontostatus',
    active: 'Aktiv',
    
    // App Settings section
    appSettings: 'App-innstillinger',
    fontSize: 'Skriftstørrelse',
    current: 'Nåværende',
    fontSizeDescription: 'Juster tekststørrelse for bedre lesbarhet på enheten din',
    small: 'Liten',
    medium: 'Middels',
    large: 'Stor',
    xlarge: 'Ekstra stor',
    huge: 'Veldig stor',
    
    // Display Settings
    displaySettings: 'Visningsinnstillinger',
    showCategories: 'Vis kategorier',
    showCategoriesDescription: 'Vis kategorihoder i handlelister som standard',
    showQuickAddButtons: 'Vis hurtigtillegg-knapper',
    showQuickAddButtonsDescription: 'Vis kategoriknapper under hurtigtillegg-tekstfeltet',
    quickAddButtons: 'Hurtigtillegg-knapper',
    categoriesDisplay: 'Kategorier',
    useGlobalSetting: 'Bruk global innstilling',
    alwaysShow: 'Vis alltid',
    alwaysHide: 'Skjul alltid',
    
    yourActivity: 'Din aktivitet',
    shoppingInsights: 'Listeinnsikter og fremgang',
    startShoppingJourney: 'Start din listereise!',
    createFirstListPrompt: 'Opprett din første liste for å se aktivitetsstatistikk her.',
    createYourFirstList: 'Opprett din første liste',
    shoppingLists: 'Lister',
    shared: 'delt',
    totalItems: 'Totalt antall elementer',
    completed: 'fullført',
    avgProgress: 'Gj.snitt fremgang',
    efficiencyScore: 'effektivitetsscore',
    editProfile: 'Rediger profil',
    saveChanges: 'Lagre endringer',
    saving: 'Lagrer...',
    cancel: 'Avbryt',
    changePassword: 'Endre passord',
    currentPassword: 'Nåværende passord',
    newPassword: 'Nytt passord',
    confirmPassword: 'Bekreft passord',
    
    // Statistics
    statisticsOverview: 'Statistikkoversikt',
    myLists: 'Mine lister',
    totalItems: 'Totalt antall elementer',
    itemsChecked: 'Elementer avkrysset',
    sharedWithMe: 'Delt med meg',
    achievements: 'Prestasjoner',
    averageProgress: 'Gjennomsnittlig fremgang',
    itemsPerList: 'Elementer per liste',
    mostProductiveList: 'Mest produktive liste',
    
    // List management
    myShoppingLists: 'Mine lister',
    newList: 'Ny liste',
    createList: 'Opprett liste',
    createNewList: 'Opprett ny liste',
    listName: 'Listenavn',
    listNameRequired: 'Listenavn *',
    description: 'Beskrivelse (Valgfritt)',
    listNamePlaceholder: 'f.eks. Ukentlig handel, Festutstyr...',
    descriptionPlaceholder: 'Legg til en beskrivelse for å organisere listen din...',
    cancel: 'Avbryt',
    creating: 'Oppretter...',
    enterListName: 'Skriv inn listenavn...',
    enterDescription: 'Skriv inn beskrivelse (valgfritt)...',
    
    // Items
    addItem: 'Legg til element',
    addNewItem: 'Legg til nytt element',
    enterItemName: 'Skriv inn elementnavn...',
    enterQuantity: 'Skriv inn antall...',
    enterNotes: 'Skriv inn notater...',
    selectCategory: 'Velg kategori...',
    searchItems: 'Søk elementer...',
    of: 'av',
    itemsCompleted: 'elementer fullført',
    
    // Item list states
    noItemsFound: 'Ingen elementer funnet',
    noItemsMatch: 'Ingen elementer matcher',
    addFirstItem: 'Start ved å legge til ditt første element i denne listen!',
    addFirstItemBtn: 'Legg til første element',
    
    // Filter tabs
    all: 'Alle',
    pending: 'Ventende',
    bought: 'Fullført',
    
    // List actions
    expandHeader: 'Utvid topptekst',
    collapseHeader: 'Skjul topptekst',
    uncheckAll: 'Fjern alle avkrysninger',
    clearChecked: 'Fjern avkryssede elementer',
    clearAllItems: 'Fjern alle elementer',
    confirmClearAll: 'Er du sikker på at du vil fjerne alle elementer fra denne listen?',
    confirmClearChecked: 'Er du sikker på at du vil fjerne alle avkryssede elementer fra denne listen?',
    confirmUncheckAll: 'Er du sikker på at du vil fjerne alle avkrysninger i denne listen?',
    itemsClearedAll: 'Alle elementer har blitt fjernet fra listen.',
    itemsClearedChecked: 'Alle avkryssede elementer har blitt fjernet fra listen.',
    itemsUnchecked: 'Alle elementer har blitt ikke-avkrysset.',
    
    // List actions
    shareList: 'Del liste',
    shareWith: 'Del med...',
    enterEmail: 'Skriv inn e-post...',
    addPeople: 'Legg til personer',
    emailAddress: 'E-postadresse',
    enterEmailAddress: 'Skriv inn e-postadresse',
    searching: 'Søker...',
    permission: 'Tillatelse',
    editAndAddItems: 'Rediger og legg til elementer',
    canEdit: 'Kan redigere',
    sharing: 'Deler...',
    peopleWithAccess: 'Personer med tilgang',
    changePermission: 'Endre tillatelse',
    removeAccess: 'Fjern tilgang',
    confirmRemoveAccess: 'Fjern tilgang for {0}?',
    accessRemoved: 'Tilgang fjernet for {0}',
    permissionUpdated: 'Tillatelse oppdatert for {0}',
    failedToRemoveAccess: 'Kunne ikke fjerne tilgang',
    failedToUpdatePermission: 'Kunne ikke oppdatere tillatelse',
    shareWithUser: 'Del med bruker',
    listShared: 'Liste delt!',
    shareListFailed: 'Kunne ikke dele liste. Prøv igjen.',
    deleteList: 'Slett liste',
    confirmDeleteList: 'Er du sikker på at du vil slette denne listen?',
    listDeleted: 'Liste slettet.',
    removeDefault: 'Fjern standard',
    setAsDefault: 'Sett som standard',
    sharedBy: 'Delt av',
    unfollow: 'Slutt å følge',
    confirmUnfollow: 'Er du sikker på at du vil slutte å følge denne listen?',
    unfollowSuccess: 'Sluttet å følge listen',
    updated: 'Oppdatert',
    
    // Messages
    noItemsYet: 'Ingen elementer i denne listen ennå.',
    noListsYet: 'Ingen lister ennå. Opprett din første liste!',
    listCreated: 'Liste opprettet!',
    listUpdated: 'Liste oppdatert!',
    itemAdded: 'Element lagt til!',
    itemUpdated: 'Element oppdatert!',
    itemDeleted: 'Element slettet!',
    duplicateItemWarning: 'Dette elementet finnes allerede i listen.',
    
    // Errors
    errorLoadingLists: 'Feil ved lasting av lister. Prøv igjen.',
    errorLoadingList: 'Feil ved lasting av liste. Prøv igjen.',
    errorCreatingList: 'Kunne ikke opprette liste. Prøv igjen.',
    errorUpdatingList: 'Kunne ikke oppdatere liste. Prøv igjen.',
    errorDeletingList: 'Kunne ikke slette liste. Prøv igjen.',
    errorAddingItem: 'Kunne ikke legge til element. Prøv igjen.',
    errorUpdatingItem: 'Kunne ikke oppdatere element. Prøv igjen.',
    errorDeletingItem: 'Kunne ikke slette element. Prøv igjen.',
    networkError: 'Nettverksfeil. Sjekk tilkoblingen din.',
    
    // Progress and completion
    progress: 'Fremgang',
    completionRate: 'Fullføringsgrad',
    allItemsChecked: 'Alle elementer avkrysset!',
    listCompleted: 'Liste fullført!',
    
    // Data Retention section
    dataRetentionPolicies: 'Dataoppbevaringspolicyer',
    monitorDataCleanup: 'Overvåk og administrer automatisk dataopprydding for å opprettholde systemytelse. Denne funksjonen hjelper med å holde dataene dine organiserte ved å fjerne gamle, ubrukte lister og elementer basert på konfigurerbare oppbevaringsperioder.',
    itemsEligibleForCleanup: 'Elementer kvalifisert for opprydding',
    maximumDataAge: 'Maksimal dataalder',
    runDataCleanup: 'Kjør dataopprydding',
    runningCleanup: 'Kjører opprydding...',
    lastCleanupResults: 'Siste oppryddingsresultater',
    itemsCleaned: 'Elementer ryddet opp:',
    listsCleaned: 'Lister ryddet opp:',
    loadingDataRetention: 'Laster dataoppbevaringsinformasjon...',
    manageDataRetention: 'Administrer dataoppbevaring',
    hideDataRetention: 'Skjul dataoppbevaring',
    dataCleanupInfo: 'Klikk på knappen nedenfor for å manuelt kjøre dataopprydding. Dette vil fjerne inaktive brukere basert på deres personlige oppbevaringspreferanse (1 år, 2 år eller på ubestemt tid). Når en bruker slettes, fjernes også alle deres lister og data.',
    dataCleanupWarning: '⚠️ Denne handlingen sletter inaktive brukere og alle deres data permanent.',
    confirmDataRetentionCleanup: 'Er du sikker på at du vil kjøre dataoppbevaringsopprydding?\n\nDette vil permanent slette:\n• Brukere som ikke har logget inn innenfor den valgte oppbevaringsperioden\n• Alle lister og data som tilhører disse inaktive brukerne\n• Foreldreløse lister (lister uten eiere)\n\nAktive brukere og deres lister slettes aldri, uavhengig av listenes alder. Administratorbrukere slettes aldri. Denne handlingen kan ikke angres.',
    
    // Quick actions
    quickActions: 'Hurtighandlinger',
    markAllComplete: 'Merk alle som ferdige',
    clearCompleted: 'Fjern fullførte',
    sortByCategory: 'Sorter etter kategori',
    sortByName: 'Sorter etter navn',
    
    // Recent Items Modal
    recentItems: 'Nylige elementer',
    recent: 'Nylige',
    searchItems: 'Søk elementer...',
    noItemsFound: 'Ingen elementer funnet',
    noRecentItems: 'Ingen nylige elementer',
    category: 'Kategori',
    general: 'Generelt',
    selectCategory: 'Velg kategori',
    editCategory: 'Rediger kategori',
    added: 'Lagt til',
    deleteItem: 'Slett element',
    confirmDelete: 'Bekreft sletting',
    confirmDeleteItem: 'Er du sikker på at du vil slette dette elementet?',
    errorUpdatingCategory: 'Feil ved oppdatering av kategori',
    errorDeletingItem: 'Feil ved sletting av element',
    
    // Enhanced Recent Items Modal
    statistics: 'Statistikk',
    totalItems: 'Totalt antall elementer',
    categories: 'Kategorier',
    mostUsedCategory: 'Mest brukte kategori',
    showStats: 'Vis statistikk',
    bulkMode: 'Masse',
    bulkSelectionMode: 'Massevalg-modus',
    name: 'Navn',
    selectAll: 'Velg alle',
    clearSelection: 'Tøm valg',
    selected: 'valgt',
    addSelected: 'Legg valgte til liste',
    deleteSelected: 'Slett valgte',
    addToList: 'Legg til liste',
    errorAddingItem: 'Feil ved tillegging av element til liste',
    errorBulkDelete: 'Feil ved sletting av valgte elementer',
    errorBulkAdd: 'Feil ved tillegging av valgte elementer',
    lastUsed: 'Sist brukt',
    
    // Compact Recent Items Modal - New Translations
    sortByRecent: 'Nyeste først',
    sortByName: 'Navn',
    sortByFrequency: 'Mest brukte',
    sortByCategory: 'Kategori',
    itemsSelected: 'elementer valgt',
    
    // Smart Seed Modal
    smartSeedDatabase: 'Smart Seed Database',
    selectContentLanguage: 'Velg innholdsspråk',
    chooseContentLanguageDesc: 'Velg språk for listeelementene dine (uavhengig av grensesnittspråk)',
    chooseTemplateType: 'Velg maltype',
    selectTemplateDesc: 'Velg hvilken type liste du vil opprette',
    categoryMapping: 'Kategorimapping',
    categoryMappingDesc: 'Koble malkategorier til dine eksisterende kategorier eller opprett nye',
    seedingDatabaseWith: 'Fyller database med:',
    createNewCategory: '✨ Opprett ny kategori',
    useExistingCategory: '📁 Bruk "{0}"',
    noExistingCategories: 'Ingen eksisterende kategorier funnet',
    newCategoriesToCreate: 'Nye kategorier som skal opprettes:',
    seedingDatabase: 'Fyller database...',
    seedDatabase: 'Fyll database',
    seedingComplete: 'Ferdig med å fylle!',
    seedingSuccessMessage: 'Vellykket tilføying av elementer til databasen for bedre autofullføring.',
    quickTip: '💡 Raskt tips',
    quickAddTipMessage: 'Alle disse elementene er nå tilgjengelige i Hurtigtillegg! Når du legger til elementer i en liste, vil du se bedre autofullføringsforslag basert på det du nettopp la til.',
    done: 'Ferdig',
    stepOf: 'Steg {0} av {1}',
    complete: 'Fullført',
    seedingError: 'Kunne ikke fylle database med elementer. Vennligst prøv igjen.'
  }
};

// Available languages
export const availableLanguages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'no', name: 'Norsk', flag: '🇳🇴' }
];

// Default language
export const defaultLanguage = 'en';

// Get translation function
export const getTranslation = (key, language = 'en', fallback = '') => {
  const langTranslations = translations[language] || translations[defaultLanguage];
  return langTranslations[key] || fallback || key;
};

// Get categories function
export const getCategories = (language = 'en') => {
  const langTranslations = translations[language] || translations[defaultLanguage];
  return langTranslations.categories || {};
};

// Get quick items function
export const getQuickItems = (language = 'en') => {
  // Return common quick-add items based on language
  if (language === 'no') {
    return [
      'Melk', 'Brød', 'Egg', 'Smør', 'Ost', 'Yoghurt', 'Frukt', 'Grønnsaker',
      'Kjøtt', 'Fisk', 'Pasta', 'Ris', 'Poteter', 'Løk', 'Hvitløk', 'Tomat'
    ];
  }
  
  // Default English
  return [
    'Milk', 'Bread', 'Eggs', 'Butter', 'Cheese', 'Yogurt', 'Fruit', 'Vegetables',
    'Meat', 'Fish', 'Pasta', 'Rice', 'Potatoes', 'Onion', 'Garlic', 'Tomato'
  ];
};
